import { render, staticRenderFns } from "./PlanProduct.vue?vue&type=template&id=61d1ab0f&"
import script from "./PlanProduct.vue?vue&type=script&lang=js&"
export * from "./PlanProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports